// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__JH0TV","icon_svg":"style_icon_svg__xHhyG"};